export default __webpack_public_path__ + "static/media/inicio.805dea46.jpg";